import { ITypedReduxAction } from '../../types/redux/actionType';

export interface IUserStatusPayload {
  userId: number;
  lastActionDatetime: string;
}

export enum EUserStatusActionTypes {
  Set = 'userStatus/set',
  Update = 'userStatus/update',
}

export type TUserStatusActions =
  | ITypedReduxAction<EUserStatusActionTypes.Set, IUserStatusPayload>
  | ITypedReduxAction<EUserStatusActionTypes.Update, { userId: number }>;
